<template>
  <div class="octadesk-loader-connectando">
    <span class="octadesk-loader-text">{{ $t(i18nKeyMessage) }}</span>

    <PulseLoader height="" width="" />
  </div>
</template>

<script>
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

  export default {
    components: { PulseLoader },
    props: {
      i18nKeyMessage: {
        type: String,
        default: 'reconnect'
      }
    }
  }
</script>

<style>
  .v-pulse {
    background-color: #5da9dd !important;
  }
  .v-pulse1 {
    width: 10px;
    height: 10px;
  }
  .v-pulse2 {
    width: 10px;
    height: 10px;
  }
  .v-pulse3 {
    width: 10px;
    height: 10px;
  }
</style>
<style scoped>
  .octadesk-loader-text {
    color: #5da9dd !important;
    margin-right: 5px;
  }
  .octadesk-loader-connectando {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    text-align: center;

    color: #5da9dd;
    z-index: 999999;
    background: rgba(245, 245, 245, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
